import React, { Component } from 'react';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import styles from './PackageInformation.scss';
import { subscriptionPick } from '../../../../actions/subscriptions';
import { withServices } from '../../../../enhancers';

class PackageInformation extends Component {
  convertNumDaysToText = (period) => {
    const textPeriod = ['one', 'two', 'three', 'four', 'five', 'six', 'eight', 'nine', 'ten', 'eleven', 'twelve'];

    return textPeriod[(period - 1)];
  }

  render() {
    const {
      title, period, type, price, originalPrice, periodInNumber,
    } = this.props;

    const monthOrYear = period.toLowerCase() === 'months' ? 'month' : 'year';
    const periodUnit = periodInNumber === 1 ? monthOrYear : period.toLowerCase();
    const convertedPeriod = this.convertNumDaysToText(periodInNumber);

    return (
      <div className={classNames(styles.root, styles[type])}>
        <div className={styles.wrapper}>
          <div className={styles.description}>
            <div>You are subscribing to:</div>
            <div className={styles.title}>
              {`${title} `}
              <span
                className={classNames(styles.price, styles[period.toLowerCase()])}
                    >
                {Number(price).toFixed(2)}
              </span>
            </div>
            { originalPrice !== undefined &&
              <div className={classNames(styles.campaignOfferRenewText)}>Renews at &#163;{originalPrice}/{monthOrYear} after {convertedPeriod} {periodUnit}.</div>
            }
            <div className={styles.cancelText}>Cancel anytime</div>
          </div>
        </div>
      </div>
    );
  }
}

PackageInformation.propTypes = {
  title: PropTypes.string.isRequired,
  period: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  price: PropTypes.string.isRequired,
};

const PackageInformationContainer =
  compose(connect(null, { subscriptionPick }))(withServices(PackageInformation));

export {
  PackageInformation,
  PackageInformationContainer as default,
};
